import React from "react";
import FormikInput from "../../../../Components/Formik/FormikInput";
import { useFormikContext } from "formik";
import { useLanguage } from "../../../../Components/LangTranslation/LanguageContext";
import { useSession } from "../../../../authentications/SessionContext";
import { primaryColor } from "../../../../utilities/colors";

function SocialMediaStep() {
  const { setFieldValue, errors, touched } = useFormikContext();
  const { language, translations } = useLanguage();
  const t = translations[language];

  return (
    <>
      <div className="my-3 col-12">
        <FormikInput name="insta_url" placeholder={t["Your Instagram Link"]} />
      </div>
      <div className="my-3 col-12">
        <FormikInput name="x_url" placeholder={t["Your X Link"]} />
      </div>
      <div className="my-3 col-12">
        <FormikInput name="fb_url" placeholder={t["Your Facebook Link"]} />
      </div>
      <div className="my-3 col-12">
        <p className="my-0 w-100" style={{ color: primaryColor.primary }}></p>
      </div>
    </>
  );
}

export default SocialMediaStep;
